import React from "react";
import { Grid, LinearProgress, Typography } from "@material-ui/core";
import { Controller, useWatch } from "react-hook-form";
import { EventNotification } from "../../domain/EventNotification";
import { SectionProps } from "./SectionProps";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { Error } from "../common/Error";

export const InherentRisk: React.FC<SectionProps<EventNotification>> = ({
  control,
  errors,
  disabled,
  registerCustomError,
}) => {
  const { inherentRiskImpact, inherentRiskLikelihood } = useWatch({
    control,
    name: ["inherentRiskImpact", "inherentRiskLikelihood"],
  });

  return (
    <Grid container spacing={3}>
      <Grid item xs={4}>
        <Controller
          control={control}
          name="inherentRiskImpact"
          rules={{ min: 0, max: 4 }}
          render={({ onChange, value }) => (
            <TextField
              onChange={(e) => {
                if (e.target.value !== null) {
                  registerCustomError("inherentRiskImpact", false);
                }
                onChange(e);
              }}
              label="Impact"
              type="number"
              value={value}
              inputProps={{ min: 0, max: 4 }}
              readOnly={disabled}
              data-test="inherent-risk-impact"
            />
          )}
        />
        {errors.inherentRiskImpact &&
          errors.inherentRiskImpact?.type !== "required" && (
            <Error>This field must be between 0-4</Error>
          )}
        {errors.inherentRiskImpact?.type === "required" && (
          <Error data-test="inherentRiskImpact-validation">
            This field is required
          </Error>
        )}
      </Grid>
      <Grid item xs={4}>
        <Controller
          control={control}
          name="inherentRiskLikelihood"
          rules={{ min: 0, max: 4 }}
          render={({ onChange, value }) => (
            <TextField
              onChange={(e) => {
                if (e.target.value !== null) {
                  registerCustomError("inherentRiskLikelihood", false);
                }
                onChange(e);
              }}
              label="Likelihood"
              type="number"
              value={value}
              inputProps={{ min: 0, max: 4 }}
              readOnly={disabled}
              data-test="inherent-risk-likelihood"
            />
          )}
        />
        {errors.inherentRiskLikelihood &&
          errors.inherentRiskLikelihood?.type !== "required" && (
            <Error>This field must be between 0-4</Error>
          )}
        {errors.inherentRiskLikelihood?.type === "required" && (
          <Error data-test="inherentRiskLikelihood-validation">
            This field is required
          </Error>
        )}
      </Grid>

      <Grid item xs={12}>
        <Typography data-test="inherent-risk-exposure">
          Exposure:{" "}
          {inherentRiskImpact && inherentRiskLikelihood
            ? inherentRiskImpact * inherentRiskLikelihood
            : 0}
        </Typography>
      </Grid>

      <Grid item xs={8}>
        <LinearProgress
          value={
            ((inherentRiskImpact && inherentRiskLikelihood
              ? inherentRiskImpact * inherentRiskLikelihood
              : 0) /
              16) *
            100
          }
          variant="determinate"
        />
      </Grid>
    </Grid>
  );
};
